export default function About() {
	return (
		<section className="container-gg py-12">
			<h1 className="text-3xl font-bold text-slate-900">About Great Grace International Christian Academy</h1>
			<p className="mt-4 max-w-3xl text-slate-700">
				We are a co-educational Christian school serving families from Nursery through Secondary. Our day school offers flexible schedules for younger learners, while our well-supervised boarding house is reserved for Secondary students seeking a focused learning environment and strong community life.
			</p>
			<p className="mt-4 max-w-3xl text-slate-700">
				Across every level, we blend national standards with international best practices, integrating faith, service, entrepreneurship, innovation, and arts. Our teachers partner with parents to nurture academic excellence, character, leadership, and global citizenship.
			</p>
			<div className="mt-8 grid gap-6 sm:grid-cols-2">
				<div className="rounded-lg border border-slate-200 p-6">
					<h3 className="font-semibold">Our Mission</h3>
					<p className="mt-2 text-sm text-slate-600">To raise confident, compassionate learners who impact their world through wisdom, creativity, and service.</p>
				</div>
				<div className="rounded-lg border border-slate-200 p-6">
					<h3 className="font-semibold">Our Vision</h3>
					<p className="mt-2 text-sm text-slate-600">To be Africa&apos;s leading day and boarding institution for whole-child education rooted in faith and excellence.</p>
				</div>
			</div>

			<div className="mt-10 grid gap-6 md:grid-cols-3">
				<div className="rounded-xl border border-slate-100 bg-slate-50 p-6">
					<p className="text-sm font-semibold uppercase tracking-wide text-brand">Holistic Care</p>
					<p className="mt-2 text-sm text-slate-700">Dedicated counsellors, chaplains, and house parents walk alongside students on campus and in the boarding house.</p>
				</div>
				<div className="rounded-xl border border-slate-100 bg-slate-50 p-6">
					<p className="text-sm font-semibold uppercase tracking-wide text-brand">Future-ready Skills</p>
					<p className="mt-2 text-sm text-slate-700">STEM labs, makerspaces, leadership internships, and entrepreneurship incubators build confidence for life after school.</p>
				</div>
				<div className="rounded-xl border border-slate-100 bg-slate-50 p-6">
					<p className="text-sm font-semibold uppercase tracking-wide text-brand">Community</p>
					<p className="mt-2 text-sm text-slate-700">Parent partnerships, outreach programs, and alumni mentoring connect every learner to a supportive network.</p>
				</div>
			</div>
		</section>
	)
}






